(function () {
    'use strict';

    /**
     * Allow a modal dialog to be movable.
     *
     <div modal-movable> <!-- add directive -->
       <div class='modal-header'> <!-- must have a child modal-header -->
       </div>
       <div class='modal-body'>
       </div>
     </div>
     */

    angular
        .module('app')
        .directive('modalMovable', modalMovable);

    function modalMovable($document) {
        return {
            restrict: 'AC',
            link: function (scope, element) {
                let startX = 0,
                    startY = 0,
                    x = 0,
                    y = 0,
                    modalHeaderClicked = false;

                let dialogWrapper = element.parent();
                while (!dialogWrapper.hasClass('modal-content') && dialogWrapper.length > 0)
                    dialogWrapper = dialogWrapper.parent();

                if (dialogWrapper.length === 0) { // modal not constructed properly
                    console.error('Modal not constructed properly for modal-movable directive. Couldn\'t find parent modal-content element.');
                    return;
                }

                dialogWrapper.css({
                    position: 'relative'
                });

                let modalHeader = Array.from(element.find('div')).find(d => d.classList.contains('modal-header'));
                if (modalHeader == null) {
                    console.error('Modal not constructed properly for modal-movable directive. Couldn\'t find child modal-header element.');
                    return;
                }

                modalHeader = angular.element(modalHeader);
                modalHeader.css({ cursor: 'move' });
                modalHeader.on('mousedown', function (event) {
                    // Prevent default dragging of selected content
                    event.preventDefault();
                    modalHeaderClicked = true;
                    startX = event.pageX - x;
                    startY = event.pageY - y;
                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                });

                function mousemove(event) {
                    if (modalHeaderClicked) {
                        y = event.pageY - startY;
                        x = event.pageX - startX;
                        dialogWrapper.css({
                            top: y + 'px',
                            left: x + 'px'
                        });
                    }
                }

                function mouseup() {
                    $document.unbind('mousemove', mousemove);
                    $document.unbind('mouseup', mouseup);
                }
            }
        };
    }
})();